import { Accordion, styled } from '@mui/material';

export const FlatAccordion = styled(Accordion)({
  border: 'none',
  boxShadow: 'none',
  '&:before': { display: 'none' },
  '&:after': { display: 'none' },
  '& .MuiAccordionSummary-root': { paddingLeft: 0, paddingRight: 0 },
  '& .MuiAccordionDetails-root': { paddingLeft: 0, paddingRight: 0 },
});
